import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Text,
  Flex,
  Icon,
  HStack,
  Button
} from '@chakra-ui/react';
import { FiTrendingUp} from 'react-icons/fi';
import FilterChips from './FilterChips';
import httpInjectorService from 'services/http-injector.service';
import { decryptData } from 'utils/crypto';
import Cookies from 'js-cookie';

const HeadingSection = ({ filters, setFilters }) => {
  const [projectList, setProjectList] = useState([]);
  const navigate = useNavigate();
  const roleid = Number(decryptData(Cookies.get('role_id')));

  //fetch project list for filter display
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await httpInjectorService.getDashboardMetrics();
        const projects = response?.data?.projectOverview ?? [];
        setProjectList(projects);
      } catch (error) {
        console.error('Failed to load projects:', error);
      }
    };

    fetchProjects();
  }, []);

  const startTourAgain = () => {
   
    window.dispatchEvent(new Event("restart-tour"));
  };

  return (
    <Box mt={8} mb={6}>
      <Flex align="flex-start" justify="space-between" gap={4} flexWrap="wrap">
        <Box flex="1" minW="300px">
          
          {/* Heading */}
      {/* <Flex
  justify="space-between"
  align="center"
  width="100%"
  mb={2}
>
  <Text
    mb={0}
    fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
    fontWeight="extrabold"
  >
    Main Dashboard
  </Text>

  <Button
    size="sm"
    colorScheme="purple"
    borderRadius="md"
    onClick={() => {
      console.log("clicked");
      startTourAgain();
    }}
  >
    Take a Tour
  </Button>
</Flex> */}
<Flex
  justify="space-between"
  align="center"
  width="100%"
  mb={2}
>
  <Text
    mb={0}
    fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
    fontWeight="extrabold"
  >
    Main Dashboard
  </Text>

  <Flex gap={2}>
    <Button
      size="sm"
      colorScheme="purple"
      borderRadius="md"
      onClick={() => {
        console.log("clicked");
        startTourAgain();
      }}
    >
      Take a Tour
    </Button>

    {/* {roleid === 1 && (
                <Button
                  size="sm"
                  colorScheme="blue"
                  borderRadius="md"
                  onClick={() => navigate('/admin/superadmin')}
                >
                  Superadmin Panel
                </Button>
              )} */}
  </Flex>
</Flex>
          

          {/* Subtitle */}
          <Flex align="center" gap={2} mt={2} mb={4}>
            <Icon as={FiTrendingUp} color="purple.500" boxSize={5} />
            <Text
              fontSize={{ base: 'sm', md: 'md', lg: 'lg' }}
              color="gray.600"
              maxW="600px"
              mb={0}
            >
              Monitor project progress, team performance, and key metrics at a glance.
            </Text>
          </Flex>

          <FilterChips
            filters={filters}
            onChange={setFilters}
            projectList={projectList}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default HeadingSection;